import React from 'react';

interface NewAssignmentProps {
  form: any;
  users: any[];
  teams: any[];
  onChange: (field: string, value: any) => void;
}

export function NewAssignment({ form, users, teams, onChange }: NewAssignmentProps) {
  return (
    <div className="bg-white p-3 rounded-md border border-slate-100 space-y-4">
      <div className="flex items-center gap-2 border-b border-slate-50 pb-2">
        <div className="w-6 h-6 rounded-full bg-blue-600 text-white flex items-center justify-center text-xs">2</div>
        <h2 className="sm:text-sm text-xs text-slate-800">Phân công & thời gian</h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="space-y-1">
          <label className="sm:text-sm text-xs text-slate-500">Người phụ trách <span className="text-red-500">*</span></label>
          <select 
            className="w-full h-9 px-3 rounded-md border border-slate-200 sm:text-sm text-xs focus:outline-none focus:ring-1 focus:ring-emerald-500 bg-slate-50/50"
            value={form.lead_user_id}
            onChange={(e) => onChange('lead_user_id', e.target.value)}
          >
            <option value="">Chọn người phụ trách</option>
            {users.map(u => <option key={u.id} value={u.id}>{u.label}</option>)}
          </select>
        </div>
        <div className="space-y-1">
          <label className="sm:text-sm text-xs text-slate-500">Người phối hợp</label>
          <div className="space-y-2">
            <select 
              className="w-full h-9 px-3 rounded-md border border-slate-200 sm:text-sm text-xs focus:outline-none focus:ring-1 focus:ring-emerald-500 bg-slate-50/50"
              value=""
              onChange={(e) => {
                const val = e.target.value;
                if (val && !form.collaborator_ids?.includes(val)) {
                  onChange('collaborator_ids', [...(form.collaborator_ids || []), val]);
                }
              }}
            >
              <option value="">Thêm người phối hợp...</option>
              {users.filter(u => u.id !== form.lead_user_id).map(u => (
                <option key={u.id} value={u.id}>{u.label}</option>
              ))}
            </select>
            
            {form.collaborator_ids && form.collaborator_ids.length > 0 && (
              <div className="flex flex-wrap gap-1">
                {form.collaborator_ids.map((userId: string) => {
                  const user = users.find(u => u.id === userId);
                  if (!user) return null;
                  return (
                    <div key={userId} className="flex items-center gap-1 px-2 py-0.5 bg-slate-100 rounded text-[10px] sm:text-xs text-slate-600 border border-slate-200">
                      <span>{user.label}</span>
                      <button 
                        type="button"
                        onClick={() => onChange('collaborator_ids', form.collaborator_ids.filter((id: string) => id !== userId))}
                        className="hover:text-red-500 transition-colors"
                      >
                        <i className="ri-close-line" />
                      </button>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
        <div className="space-y-1">
          <label className="sm:text-sm text-xs text-slate-500">Nhóm/Đội</label>
          <select 
            className="w-full h-9 px-3 rounded-md border border-slate-200 sm:text-sm text-xs focus:outline-none focus:ring-1 focus:ring-emerald-500 bg-slate-50/50"
            value={form.assigned_team_id}
            onChange={(e) => onChange('assigned_team_id', e.target.value)}
          >
            <option value="">Chọn nhóm/đội</option>
            {teams.map(t => <option key={t.id} value={t.id}>{t.label}</option>)}
          </select>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="space-y-1">
          <label className="sm:text-sm text-xs text-slate-500">Ngày bắt đầu <span className="text-red-500">*</span></label>
          <div className="relative">
            <input 
              type="date" 
              className="w-full h-9 px-3 rounded-md border border-slate-200 sm:text-sm text-xs focus:outline-none focus:ring-1 focus:ring-emerald-500 bg-slate-50/50"
              value={form.planned_start_date}
              onChange={(e) => onChange('planned_start_date', e.target.value)}
            />
          </div>
        </div>
        <div className="space-y-1">
          <label className="sm:text-sm text-xs text-slate-500">Ngày kết thúc dự kiến <span className="text-red-500">*</span></label>
          <div className="relative">
            <input 
              type="date" 
              className="w-full h-9 px-3 rounded-md border border-slate-200 sm:text-sm text-xs focus:outline-none focus:ring-1 focus:ring-emerald-500 bg-slate-50/50"
              value={form.planned_end_date}
              onChange={(e) => onChange('planned_end_date', e.target.value)}
            />
          </div>
        </div>
        <div className="space-y-1">
          <label className="sm:text-sm text-xs text-slate-500">Thời gian ước tính</label>
          <div className="relative">
            <input 
              type="text" 
              placeholder="Nhập thời gian (giờ)" 
              className="w-full h-9 px-3 pr-10 rounded-md border border-slate-200 sm:text-sm text-xs focus:outline-none focus:ring-1 focus:ring-emerald-500 bg-slate-50/50"
              value={form.estimated_hours}
              onChange={(e) => onChange('estimated_hours', e.target.value)}
            />
            <span className="absolute right-3 top-1/2 -translate-y-1/2 sm:text-sm text-xs text-slate-400">giờ</span>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-1">
          <label className="sm:text-sm text-xs text-slate-500">Ưu tiên</label>
          <select 
            className="w-full h-9 px-3 rounded-md border border-slate-200 sm:text-sm text-xs focus:outline-none focus:ring-1 focus:ring-emerald-500 bg-slate-50/50"
            value={form.priority_code}
            onChange={(e) => onChange('priority_code', e.target.value)}
          >
            <option value="high">Cao</option>
            <option value="medium">Trung bình</option>
            <option value="low">Thấp</option>
          </select>
        </div>
        <div className="space-y-1">
          <label className="sm:text-sm text-xs text-slate-500">Trạng thái mặc định</label>
          <select className="w-full h-9 px-3 rounded-md border border-slate-200 sm:text-sm text-xs focus:outline-none focus:ring-1 focus:ring-emerald-500 bg-slate-50/50">
            <option value="assigned">Đang thực hiện</option>
            <option value="draft">Mới tạo</option>
          </select>
        </div>
      </div>
    </div>
  );
}
